import { Component, OnInit } from '@angular/core';
import { UntypedFormGroup, UntypedFormBuilder, Validators } from '@angular/forms';

import { Auth } from 'src/providers/auth/auth';
import { Client } from 'src/providers/client/client';
import { CustomNavController } from 'src/shared/providers/navigation/custom-nav-controller';
import { Events } from 'src/providers/events/events';
import { CookieProvider } from 'src/providers/cookie/cookie';
import { Me } from 'src/providers/me/me';
import { Proposals } from 'src/providers/proposals/proposals';
import { UtmService } from 'src/providers/utm/utm.service';

import { validateEmail } from 'src/shared/validator/validateEmail';
import validationUtils from 'src/shared/util/validation-utils';

@Component({
    templateUrl: 'create-account-to-book.html',
    standalone: false
})

export class CreateAccountToBookPage implements OnInit {

  customerResponse: any;
  errorMessage: string;
  form: UntypedFormGroup;
  proposal: any;
  submitted: boolean;
  termsError: boolean;
  utmzTidy: any;


  boundCreateAccount = this.createAccount.bind(this);

constructor(
    private auth: Auth,
    private client: Client,
    private fb: UntypedFormBuilder,
    private formBuilder: UntypedFormBuilder,
    private events: Events,
    private cookieProvider: CookieProvider,
    private me: Me,
    private navCtrl: CustomNavController,
    private proposals: Proposals,
    private utmService: UtmService
  ) {
    this.form = this.fb.group({
      firstName: ['', Validators.required],
      lastName: ['', Validators.required],
      email: ['', [Validators.required, validationUtils.validateEmail]],
      password: ['', Validators.required],
      terms: [true, Validators.requiredTrue]
    });
  }

  ngOnInit() {
    // Capture UTMs from URL if present
    this.utmService.captureUtmsFromUrl();
    this.proposal = this.navCtrl.getParam('proposal');
    this.form.patchValue({email: this.proposal.customer.email});
  }

  async createAccount() {
    this.submitted = true;
    this.termsError = false;
    if (this.proposal.customer.email !== this.form.value.email) {
      return this.errorMessage = 'This proposal was sent to a different user. Please log into the user the proposal was sent to.';
    }
    if (!this.form.valid) {
      if (!this.form.controls.terms.valid) {
        this.termsError = true;
      }
      return;
    }
    try {
      await this.createUser();
      await this.updateCustomer();
      localStorage.setItem('addressId', this.proposal.customer.address_ids[0]);
      this.proposals.goToBookJob(this.proposal);
    } catch (err) {
      localStorage.clear();
      this.errorMessage = err.message;
    }
  }

  async createUser() {
    await this.authLogin('signUp');
    await this.getCustomers();
    this.auth.setSession();
    await this.authLogin('signUpPassword');
  }

  async authLogin(scope) {
    const credentials = this.getCredentials();
    const privateProSignUpData = null
    await this.auth.login(credentials, scope, privateProSignUpData);
  }

  getCredentials() {
    const utms = this.utmService.getUtmsForAuth();
    return {
      username: this.form.value.email,
      password: this.form.value.password,
      date_added_to_cookie: utms.date_added_to_cookie,
      utm_source: utms.utm_source,
      utm_medium: utms.utm_medium,
      utm_campaign: utms.utm_campaign,
      utm_term: utms.utm_term,
      utm_content: utms.utm_content
    };
  }

  async getCustomers() {
    const customersObj = this.getCustomer();
    this.customerResponse = await this.client.getCustomers(customersObj);
  }

  getCustomer() {
    return {
      'customer': {
        'booked_via': 'Self Booking',
        'email': this.form.value.email,
        'first_name': this.form.value.firstName,
        'last_name': this.form.value.lastName,
        'password': this.form.value.password,
        'account_type': 'regular',
        'account_name': '',
      }
    }
  }

  async updateCustomer() {
    await this.client.updateCustomer({customer: {developer: false}}, this.customerResponse.id);
  }

  goToClientHub() {
    const clientHubUuId = this.navCtrl.getParam('clientHubUuId');
    this.navCtrl.navigateForward(`client/${clientHubUuId}`);
  }
}
